import { CloseCircleOutlined } from '@ant-design/icons';
import { Button, DatePicker, Flex } from 'antd';

import { MultipleSelect } from '@app/components';
import { DATE_PICKER_FORMAT } from '@app/constants';
import type { FiltersProps } from '@app/pages/PaymentDocuments/components/PaymentDocumentsRegistry/types';

import type { BaseOptionType } from 'antd/es/select';

const { RangePicker } = DatePicker;

export const Filters: React.FC<FiltersProps> = ({
  onReset,
  onSearch,
  disabled,
  organizationIds,
  setOrganizationIds,
  documentTypes,
  setDocumentTypes,
  statuses,
  setStatuses,
  period,
  setPeriod,
  filters,
}) => {
  const mapDictionaryToSelectOptions = (
    dict: Record<string, string>
  ): BaseOptionType[] =>
    Object.entries(dict).map(([value, label]) => ({
      value,
      label,
    }));

  return (
    <Flex className={'filters'} align="center" wrap="wrap" gap={12}>
      <RangePicker
        value={period}
        onChange={(period) => {
          setPeriod(period);
        }}
        className={'filters_date'}
        placeholder={['Дата с', 'Дата по']}
        disabled={disabled}
        format={DATE_PICKER_FORMAT}
      />
      <MultipleSelect
        placeholder="Все организации"
        allOptions={mapDictionaryToSelectOptions(filters?.Organizations || {})}
        width={100}
        selectedOption={organizationIds}
        setSelectedOptions={setOrganizationIds}
        disabled={disabled}
      />
      <MultipleSelect
        placeholder="Все документы"
        allOptions={mapDictionaryToSelectOptions(filters?.DocumentTypes || {})}
        width={100}
        selectedOption={documentTypes}
        setSelectedOptions={setDocumentTypes}
        disabled={disabled}
      />
      <MultipleSelect
        placeholder="Все статусы"
        allOptions={mapDictionaryToSelectOptions(filters?.Statuses || {})}
        width={100}
        selectedOption={statuses}
        setSelectedOptions={setStatuses}
        disabled={disabled}
      />
      <div className={'filters_buttons'}>
        <Button
          htmlType="reset"
          onClick={onReset}
          className={'filters_buttons_item'}
        >
          <CloseCircleOutlined />
          Сброс
        </Button>
        <Button
          type="primary"
          onClick={onSearch}
          className={'filters_buttons_item'}
        >
          Показать
        </Button>
      </div>
    </Flex>
  );
};
